import axios from "axios";
import { BRAND } from "@/lib/brand";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// creds = { server, username, password }
export const xtreamLogin = (creds) =>
  client.post("/xtream/login", creds).then((r) => r.data);

export const getVodCategories = (creds) =>
  client.post("/xtream/vod-categories", creds).then((r) => r.data);

export const getVodStreams = (creds, category_id = null) =>
  client.post("/xtream/vod-streams", { ...creds, category_id }).then((r) => r.data);

export const getVodInfo = (creds, vod_id) =>
  client.post("/xtream/vod-info", { ...creds, vod_id }).then((r) => r.data);

export const getSeriesCategories = (creds) =>
  client.post("/xtream/series-categories", creds).then((r) => r.data);

export const getSeries = (creds, category_id = null) =>
  client.post("/xtream/series", { ...creds, category_id }).then((r) => r.data);

export const getSeriesInfo = (creds, series_id) =>
  client.post("/xtream/series-info", { ...creds, series_id }).then((r) => r.data);

// Proxy remote poster images (handles http panels + CORS)
export const imageUrl = (url) => {
  if (!url) return null;
  return `${API}/xtream/image?url=${encodeURIComponent(url)}`;
};

const cleanServer = (server) => (server || "").trim().replace(/\/+$/, "");

// Build an HTTPS stream origin from the session so links work from an HTTPS app
// (avoids browser mixed-content blocking). Falls back to the entered server.
export const streamBase = (session) => {
  const creds = session?.creds || {};
  const info = session?.serverInfo || {};
  let host = info.url;
  if (!host) {
    try {
      const raw = creds.server?.startsWith("http") ? creds.server : `http://${creds.server}`;
      host = new URL(raw).hostname;
    } catch {
      return cleanServer(creds.server);
    }
  }
  host = String(host).replace(/^https?:\/\//, "").replace(/\/+$/, "");
  const hport = info.https_port ? String(info.https_port) : "";
  return hport && hport !== "443" ? `https://${host}:${hport}` : `https://${host}`;
};

// Direct stream/download links to the panel (top-level navigation is allowed)
export const movieStreamUrl = (creds, streamId, ext = "mp4", base) =>
  `${base || cleanServer(creds.server)}/movie/${encodeURIComponent(creds.username)}/${encodeURIComponent(
    creds.password
  )}/${streamId}.${ext || "mp4"}`;

export const episodeStreamUrl = (creds, episodeId, ext = "mp4", base) =>
  `${base || cleanServer(creds.server)}/series/${encodeURIComponent(creds.username)}/${encodeURIComponent(
    creds.password
  )}/${episodeId}.${ext || "mp4"}`;

// Stream/download through our own backend so the browser never hits the panel's
// Cloudflare directly (avoids the Cloudflare video-restriction page + mixed content).
export const proxyStreamUrl = (creds, kind, id, ext = "mp4", download = false) => {
  const params = new URLSearchParams({
    server: BRAND.streamServer || creds.server,
    username: creds.username,
    password: creds.password,
    type: kind === "series" ? "series" : "movie",
    id: String(id),
    ext: ext || "mp4",
  });
  if (download) params.set("download", "1");
  return `${API}/xtream/stream?${params.toString()}`;
};
